// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuillMultiSelect-base__eW4l6{display:flex;flex-direction:column;gap:var(--size-1);min-width:var(--size-40)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "QuillMultiSelect-base__eW4l6"
};
export default ___CSS_LOADER_EXPORT___;
